import { BusinessMemberDto, BusinessMemberModel } from '../../data-layer/business/types';

export const fromBusinessMemberDto = (
    businessMemberDto: BusinessMemberDto,
): BusinessMemberModel => ({
    login: businessMemberDto.login,
    avatarUrl: businessMemberDto.avatar_url,
    memberId: businessMemberDto.member_id,
    displayName: businessMemberDto.display_name,
    isCurrentUser: businessMemberDto.is_current_user,
    status: businessMemberDto.status,
});
